import type { IGoogleLocationType, TAddressDetectionType } from 'api/swagger';

interface IAddressStatusOptions {
  withoutLike?: boolean;
  detectionType?: TAddressDetectionType;
}

export const addressStatus = (googleLocationType?: IGoogleLocationType, options?: IAddressStatusOptions) => {
  const { withoutLike = false, detectionType } = options || {};
  if (detectionType === 'manual') return '✍️';
  if (googleLocationType === 'ROOFTOP') return withoutLike ? '' : '😍';
  if (googleLocationType === 'RANGE_INTERPOLATED') return '';
  if (googleLocationType === 'GEOMETRIC_CENTER') return '';
  if (googleLocationType === 'APPROXIMATE') return '🤮';
  if (!googleLocationType) return '🤮';
  return '😒';
};
